module.exports = __webpack_public_path__ + "static/media/import-colaborator.5c565f1b.svg";